import Formsy from "formsy-react";
import React from "react";

import FiltersWrapperAbstract from "../../../../../../../abstract/FiltersWrapperAbstract";
import FormsyComposedNewTextField from "../../../../../../../lib/FormBuilder/FormsyMaterialUI/FormsyComposedNewTextField";
import ApiHelper from "../../../../../../../lib/UniversalTable/CoreHelpers/ApiHelper";
import FilterOptionsHelper from "../../../../../../../lib/UniversalTable/CoreHelpers/FilterOptionsHelper";
import {
  FILTER_KIND,
  getFilterKind,
  getOrderedFilterableColumns
} from "../../../../../../../lib/UniversalTable/filterOrderWeights";
import { isFilterAttributeLocked } from "../../../../../../../lib/UniversalTable/lockedSettings";
import DynamicAutocompleteFilter from "./DynamicAutocompleteFilter";
import SingleRadioFilter from "./SingleRadioFilter";
import SingleRangeFilter from "./SingleRangeFilter";
import SingleValueFilter from "./SingleValueFilter";
import TrendStatusCheckboxFilter from "./TrendStatusCheckboxFilter";

class OrderedFilters extends FiltersWrapperAbstract {
  isLocked(attribute) {
    return isFilterAttributeLocked(this.props.lockedSettings, attribute);
  }

  setSearch(attribute, value) {
    if (this.isLocked(attribute)) {
      return;
    }
    const {
      settingsState: { search }
    } = this.props;

    const newSearch = { ...search };

    delete newSearch[attribute];

    if (value && value.length) {
      newSearch[attribute] = value;
    }

    this.props.setSettingsState({
      search: newSearch
    });
  }

  applySetting(attribute, value) {
    if (this.isLocked(attribute)) {
      return;
    }

    super.applySetting(attribute, value);
  }

  renderValueFilter(column) {
    const { settingsState } = this.props;
    const filterKey = ApiHelper.getColumnAttributeForFiltering(column);
    const filterProps = {
      value: settingsState.filters[filterKey],
      onChange: value => {
        this.applySetting(filterKey, value);
      },
      column,
      disabled: this.isLocked(filterKey)
    };

    if (FilterOptionsHelper.isTrendStatusColumn(column)) {
      return <TrendStatusCheckboxFilter key={filterKey} {...filterProps} />;
    }

    return <SingleValueFilter key={filterKey} {...filterProps} />;
  }

  renderSearchFilter(column) {
    const { settingsState } = this.props;
    const filterKey = ApiHelper.getColumnAttributeForFiltering(column);

    return (
      <div className="filters-item-wrapper half-width" key={filterKey}>
        <FormsyComposedNewTextField
          name={filterKey}
          label={column.label}
          translateLabel={false}
          value={settingsState.search[filterKey] || ""}
          disabled={this.isLocked(filterKey)}
          onChange={value => {
            this.setSearch(filterKey, value);
          }}
        />
      </div>
    );
  }

  renderDynamicAutocompleteFilter(column) {
    const { settingsState } = this.props;
    const filterKey = ApiHelper.getColumnAttributeForFiltering(column);

    return (
      <div className="filters-item-wrapper half-width" key={filterKey}>
        <DynamicAutocompleteFilter
          name={filterKey}
          label={column.label}
          value={settingsState.search[filterKey] || ""}
          filterDataUrl={column.filter_data.url}
          disabled={this.isLocked(filterKey)}
          onSelect={ticker => {
            this.setSearch(filterKey, ticker);
          }}
        />
      </div>
    );
  }

  renderFilter(column) {
    const { settingsState } = this.props;
    const filterKey = ApiHelper.getColumnAttributeForFiltering(column);
    const kind = getFilterKind(column);

    switch (kind) {
      case FILTER_KIND.RADIO:
        return (
          <SingleRadioFilter
            key={filterKey}
            value={settingsState.filters[filterKey]}
            onChange={value => {
              this.applySetting(filterKey, value);
            }}
            column={column}
            disabled={this.isLocked(filterKey)}
          />
        );
      case FILTER_KIND.VALUES:
        return this.renderValueFilter(column);
      case FILTER_KIND.DYNAMIC_AUTOCOMPLETE:
        return this.renderDynamicAutocompleteFilter(column);
      case FILTER_KIND.SEARCH:
        return this.renderSearchFilter(column);
      case FILTER_KIND.RANGE:
        return (
          <SingleRangeFilter
            key={filterKey}
            value={settingsState.filters[filterKey]}
            onChange={value => {
              this.applySetting(filterKey, value);
            }}
            column={column}
            disabled={this.isLocked(filterKey)}
          />
        );
      default:
        return null;
    }
  }

  render() {
    const { columns, hasPermission } = this.props;
    const orderedColumns = getOrderedFilterableColumns(
      columns,
      hasPermission
    );

    if (!orderedColumns.length) {
      return null;
    }

    return (
      <Formsy>
        <div className="filters-wrapper">
          {orderedColumns.map(column => this.renderFilter(column))}
        </div>
      </Formsy>
    );
  }
}

export default OrderedFilters;
